import { Component } from '@angular/core';
import { TituloModule } from './../models/historial.model';
import { PacientesService } from '../services/pacientes.service';
import { ActivatedRoute, Router, Params } from '@angular/router';


@Component({
  selector : 'App-historial',
  templateUrl : './../views/historial.component.html',
  styleUrls : ['./../css/historial.component.css'],
  providers: [PacientesService]
})

export class HistorialComponent {

    public titulo: TituloModule;
    public paciente= {id:'',full_name:'',rut:'',birthdate:'',address:'',phone:''};
    public consultas:any;
    
    // public paciente: DatosPaciente[];

    constructor(
      private _pacientesEditService: PacientesService,
      private _route: ActivatedRoute,
      private _router: Router
    ) {
      this.titulo = new TituloModule('Detalles del paciente');

    }
    ngOnInit(): void {
      // Called after the constructor, initializing input properties, and the first call to ngOnChanges.
      // Add 'implements OnInit' to the class.
      this.getPaciente();
    }

    getPaciente() {
      
      this._route.params.forEach((params: Params) => {
          const id = params.id;
          this._pacientesEditService.getPaciente(id).subscribe(
              response => {
                this.consultas = response.request.consultations;   
                this.paciente = response.request.patient; 
                console.log(this.paciente);
                console.log(this.consultas);
          },
          error => {
              console.log(error as any);
          }
          );
      });

  }
}

// var myJSON = JSON.stringify(response.request.patient);
//console.log(myJSON);

/*********************************************************************************************************************
 Construido y distribuido por IT-SolutionsSpa, soluciones informáticas para su negocio 
Santiago, Chile 2019,
Ingeniero de Software FrontEnd: Rodrigo Neira
Ingeniero de Software BackEnd: Octavio Cubillos
Gestor: Edison Núñez
mayor informacion a contacto@itsolutonsspa.cl
o en www.itsolutionsspa.cl 
 ********************************************************************************************************************/